package com.kanati.admin.components

import androidx.compose.runtime.Composable
import com.kanati.admin.state.MaterialThemePalette
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun SectionCard(
    title: String,
    theme: MaterialThemePalette,
    description: String? = null,
    headerActions: (@Composable () -> Unit)? = null,
    content: @Composable () -> Unit,
) {
    Div(
        attrs = {
            style {
                borderRadius(24.px)
                padding(22.px)
                display(DisplayStyle.Flex)
                flexDirection(org.jetbrains.compose.web.css.FlexDirection.Column)
                gap(14.px)
                property("background-color", theme.surfaceContainerHigh)
                property("border", "1px solid ${theme.outline}")
                property("box-shadow", "0 12px 30px ${theme.shadow}")
            }
        }
    ) {
        Div(
            attrs = {
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(org.jetbrains.compose.web.css.FlexDirection.Column)
                    gap(14.px)
                }
            }
        ) {
            Div(
                attrs = {
                    style {
                        property("display", "flex")
                        property("justify-content", "space-between")
                        property("align-items", "start")
                        property("gap", "14px")
                        property("flex-wrap", "wrap")
                    }
                }
            ) {
                Div(
                    attrs = {
                        style {
                            property("display", "flex")
                            property("flex-direction", "column")
                            property("gap", "8px")
                            property("max-width", "720px")
                        }
                    }
                ) {
                    H2(
                        attrs = {
                            style {
                                margin(0.px)
                                property("color", theme.onSurface)
                                property("font-family", "\"SF Pro Display\", \"Avenir Next\", sans-serif")
                                property("font-size", "1.45rem")
                                property("line-height", "1.08")
                                property("letter-spacing", "-0.03em")
                            }
                        }
                    ) {
                        Text(title)
                    }

                    description?.let {
                        P(
                            attrs = {
                                style {
                                    margin(0.px)
                                    property("color", theme.onSurfaceVariant)
                                    property("font-size", "0.94rem")
                                    property("line-height", "1.5")
                                }
                            }
                        ) {
                            Text(it)
                        }
                    }
                }

                headerActions?.let { actions ->
                    Div(
                        attrs = {
                            style {
                                property("display", "flex")
                                property("align-items", "center")
                                property("gap", "10px")
                                property("flex-wrap", "wrap")
                            }
                        }
                    ) {
                        actions()
                    }
                }
            }

            content()
        }
    }
}
